export default __webpack_public_path__ + "static/media/1415 spice rack side.558376a7.png";